import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { AssistMigrationProfileListResult } from 'types/assist/assistMigration';

export interface GetAssistMigrationProfilesParams {
  search?: string;
  page?: number;
  pageSize?: number;
  hasAssistSettings?: boolean;
  isLaundroworksConnected?: boolean;
  [key: string]: string | number | boolean | undefined;
}

interface GetAssistMigrationProfilesResponse {
  success: boolean;
  data: AssistMigrationProfileListResult;
}

export const getAssistMigrationProfiles = (
  params: GetAssistMigrationProfilesParams = {},
): AxiosPromise<GetAssistMigrationProfilesResponse> =>
  httpClient({
    method: 'GET',
    url: '/super-admin/businesses/profiles',
    params,
  });
